<template>
  <div class="company-intro-content">
    <title-bar
      title-light="我们"
      title="关于"
      desc="多种荣誉证书已获得司法认可"
      :title-prev="true"
    ></title-bar>
    <div class="company-intro-content__main wrap">
      <div class="main-l">
        “星星之火、可以燎原”。自成立以来，温州星原统计服务有限公司经历从无到有、从小到大、从弱到强的发展蜕变，迅速成长为本地统计调查行业具有四个“唯一”的实力型企业：唯一具备承接县级全区域普查工作经验；唯一具备信息技术自主开发能力；唯一具备中小企业服务平台指定服务资格；唯一具备科技云平台指定服务资格。<br /><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司目前已建成专职调查员50多人、长期兼职调查员200多人、其他兼职调查员500多人的庞大调查员团队；先后引进面访调查和电话调查等专业调查系统；自主研发“铃铃调查”系统、调查员管理系统、网络台账系统、统计培训系统等一系列专业信息系统，形成包括“统计调查服务”、“统计报表代理”及“统计软件开发”等三大产品体系。长期以来，公司积极深化和开拓服务领域，服务对象已包括统计、经信、科技、环保、农业等职能部门，服务区域覆盖鹿城、龙湾、瓯海等三大主城区，服务级别涵盖市、县、乡等三级行政机构。统计调查对象已经超过100000个单位，帮助客户或提高决策质量，或提升绩效表现，或影响公共事务决策，或创新公共服务运作，或构建全新数据平台，成功塑造在业界享有盛誉的“星原统计”品牌形象。
      </div>
      <div class="main-r">
        <img
          class="img"
          src="@/assets/images/about-us/services.png"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar'

export default {
  name: 'CompanyIntroContent',
  components: {
    TitleBar
  }
}
</script>

<style lang="less" scoped>
.company-intro-content {
  .title-bar {
    padding: 70px 0 77px;
  }
  &__main {
    display: flex;
    align-items: center;
    .main-l {
      flex: 1;
      font-size: 16px;
      text-indent: 2em;
      text-align: justify;
    }
    .main-r {
      flex: 1;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
